module.exports = __webpack_public_path__ + "assets/img/title-bg-2.ca392521.png";